import React from "react";
import close from "../assets/images/modal-close.svg";
import modaldecoration from "../assets/images/modal-decoration.svg";
import Form from "../components/Form"

function stopPropagation(e) {
  e.stopPropagation();
}

function ModalSignup({ toggleModal }) {

  return (
    <>
      <div className="modal-wappar" onClick={() => toggleModal()}>
        <div className="outer" onClick={stopPropagation}>
        <div className="inner">
        <div className="content">
        <Form/>
        <div className="close">
            <img
              src={close}
              alt="close"
              className="close-btn-modal "
              onClick={() => toggleModal()}
            />
          </div>
          <img src={modaldecoration} alt="" className="modal-decoration"/>
          </div>
          </div>
        </div>
        </div>
    </>
  );
}

export default ModalSignup;
